import React from 'react';
import { Link } from 'react-router-dom';
import VideoModal from './VideoModal';
import './Footer.css';

const Footer = ({ onHowItWorksClick }) => {
  const [showVideo, setShowVideo] = React.useState(false);

  const handleHowItWorksClick = (e) => {
    e.preventDefault();
    if (onHowItWorksClick) {
      onHowItWorksClick();
    } else {
      setShowVideo(true);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">

          <div className="footer-col">
            <div className="footer-logo">
              <img src={process.env.PUBLIC_URL + '/Sayagain.png'} alt="SayAgain" className="footer-logo-img" />
            </div>
            <p className="footer-desc">
              Preserving the voices that matter most, so the people you love are never out of reach.
            </p>
          </div>

          <div className="footer-col-center">
            <div className="footer-links">
              <a href="/signup" className="footer-link-teal" onClick={handleHowItWorksClick}>How It Works</a>
              <Link to="/legal" className="footer-link-teal">Legal</Link>
              <Link to="/contact" className="footer-link-teal">Contact us</Link>
            </div>
          </div>

          <div className="footer-col" />

        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} SayAgain. All rights reserved.
        </div>
      </div>

      <VideoModal
        show={showVideo}
        onHide={() => setShowVideo(false)}
        videoSrc={process.env.PUBLIC_URL + '/480p_SayAgain.mp4'}
      />
    </footer>
  );
};

export default Footer;
